export const PROFILES_LIST_ACTION = "PROFILES_LIST_ACTION"
export const ADD_PROFILE_ACTION = "ADD_PROFILE_ACTION";
export const UPDATE_PROFILE_ACTION = 'UPDATE_PROFILE_ACTION';


export const profilesList=(profilesList)=>({
    type: PROFILES_LIST_ACTION ,
    payload: profilesList

})

export const addProfile = (profile) => ({
    type: ADD_PROFILE_ACTION,
    payload: profile,
});

export const updateProfile = (profile) => ({
    type: UPDATE_PROFILE_ACTION,
    payload: profile,
  });

  